<div style="margin: 5px 5px 5px 5px">
  <mat-form-field class="api-select-field">
    <mat-label>Search or select a service</mat-label>
    <input matInput
           autocomplete="off"
           [formControl]="apiQuery"
           [matAutocomplete]="apiOptions"
           (input)="onApiInput()"
           (blur)="restoreSelectedApi()">
    @if (hasQueryText) {
      <button type="button"
              mat-icon-button
              matSuffix
              aria-label="Clear search"
              (mousedown)="$event.preventDefault()"
              (click)="clearQuery()">
        <mat-icon>close</mat-icon>
      </button>
    }
    <mat-autocomplete #apiOptions="matAutocomplete"
                      panelWidth="auto"
                      [displayWith]="displayApi"
                      (optionSelected)="setService($event.option.value)">
      @if (registerLoaded && groups.length === 0) {
        <mat-option disabled>No API matches the query</mat-option>
      }
      @for (group of groups; track group.label) {
        <mat-optgroup [label]="group.label">
          @for (entry of group.endpoints; track entry.key) {
            <mat-option [value]="entry.key">{{entry.label}}</mat-option>
          }
        </mat-optgroup>
      }
    </mat-autocomplete>
  </mat-form-field>
  @if (selectedService) {
    <div>
      <form>
        <p>Selected service: {{selectedService.title}}</p>
        @for (parameter of selectedService.parameters ?? []; track parameter) {
          @if (['add_to_path', 'string', 'number', 'list'].includes(parameter.param_type)) {
            <mat-form-field>
              <mat-label>{{parameter.title}}</mat-label>
              <input matInput [formControl]="parameter.formControl">
            </mat-form-field>
          }
          @if (parameter.param_type === 'object') {
            <mat-form-field>
              <mat-label>{{parameter.title}}</mat-label>
              <textarea matInput [formControl]="parameter.formControl"></textarea>
            </mat-form-field>
          }
        }
        <button type="submit" mat-button (click)="executeService()">Execute service</button>
      </form>
    </div>

  }
  @if (executing) {
    <div>
      <p>Executing service...</p>
    </div>
  } @else if (executeTime) {
    <div>
      <p>Execution time: {{executeTime}} ms</p>
    </div>
  }
  @if (executeResult) {
    <div>
      <p>Last result:</p>
      <pre style="background: #b3b4b4">{{executeResult | json}}</pre>
    </div>
  }
  @if (errorMessage) {
    <div>
      <p>Error occurred:</p>
      <pre style="color: darkred">{{errorMessage}}</pre>
    </div>
  }

</div>
